export default __webpack_public_path__ + "static/media/SeaLife_02.d5aefff7.png";